import { Card, SxProps, Theme } from '@mui/material'
import React from 'react'

interface P {
    index?: number
    children?: JSX.Element | JSX.Element[] | string
    style?: React.CSSProperties
    className?: string
    sx?: SxProps<Theme>
    flex?: number
    rows?: number
    table?: boolean
}

function SmartCard({ style, sx, flex, rows, className, children, table }: P) {
    return (
        <Card
            style={{ ...{ flex, display: 'flex', flexDirection: 'column' }, ...style }}
            className={`${table ? 'smart-table' : ''} ${className ?? ''}`.trim()}
            sx={sx ?? { p: 3, height: rows ? ('calc(var(--unit) * 15 * ' + rows + ')') : '100%' }}>
            {children}
        </Card>
    )
}

export default SmartCard
